<template>
   <div class="home-page container">
        <div class="columns">
            <div class="column">
                <unreceived-pos></unreceived-pos>
            </div>
        </div>
    </div>
</template>

<script>
import UnapprovedPOs from './UnapprovedPOs';
import UnreceivedPOs from './UnreceivedPOs';
import { mapState } from 'vuex';
import { mapMutations } from 'vuex';
import store from '../../store/store.js';

export default {
  name: 'DashboardPage',
  components: {
    'unapproved-pos': UnapprovedPOs,
    'unreceived-pos': UnreceivedPOs
  },
  data () {
    return {
    };
  },
  computed:{
    ...mapState([
      'currentPage',
    ]),
  },
  methods:{
    ...mapMutations([
        'updateCurrentPage'
    ]),
  },
  created: function(){
      store.commit('updateCurrentPage', 'dashboard');
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.column{
    margin: 10px 10px 10px 10px;
}
</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/DashboardPage.vue